import React from "react";
import Link from "next/link";
import { BiPhone, BiEnvelope, BiLogoLinkedin, BiRocket, BiCheckCircle, BiLineChart, BiCog, BiData } from "react-icons/bi";
import { useTranslations } from '../../../locales/useTranslations';
import FadeInAnimation from '../../Common/FadeInAnimation';

const MetabaseCTA = () => {
    const { t } = useTranslations();

    const benefits = [
        { icon: BiLineChart, text: t("metabase_cta_description") },
        { icon: BiData, text: t("metabase_cta_description2") },
        { icon: BiCog, text: t("metabase_cta_description3") },
        { icon: BiCheckCircle, text: t("metabase_cta_description4") },
    ];

    return (
        <section className="metabase-cta">
            {/* Dekorationen */}
            <div className="metabase-cta__decoration metabase-cta__decoration--1"></div>
            <div className="metabase-cta__decoration metabase-cta__decoration--2"></div>

            <div className="container">
                {/* Benefits Sektion */}
                <FadeInAnimation direction="up" delay={100}>
                    <div className="metabase-cta__section">
                        <div className="metabase-cta__header">
                            <h2 className="metabase-cta__title">
                                {t("metabase_cta_title")}
                            </h2>
                            <div className="metabase-cta__title-line"></div>
                        </div>

                        <div className="metabase-cta__benefits">
                            {benefits.map((benefit, index) => (
                                <FadeInAnimation key={index} direction="up" delay={150 + index * 50}>
                                    <div className="metabase-cta__benefit-card">
                                        <div className="metabase-cta__benefit-icon">
                                            <benefit.icon />
                                        </div>
                                        <p className="metabase-cta__benefit-text">{benefit.text}</p>
                                    </div>
                                </FadeInAnimation>
                            ))}
                        </div>
                    </div>
                </FadeInAnimation>

                {/* Zusammenfassung Sektion */}
                <FadeInAnimation direction="up" delay={200}>
                    <div className="metabase-cta__section metabase-cta__section--highlight">
                        <h3 className="metabase-cta__subtitle">
                            {t("metabase_cta_title5")}
                        </h3>
                        <p className="metabase-cta__description">
                            {t("metabase_cta_description5")}
                        </p>
                        <div className="metabase-cta__button-wrapper">
                            <Link href="/kontakt" className="metabase-cta__button">
                                <BiRocket />
                                <span>Jetzt starten</span>
                            </Link>
                        </div>
                    </div>
                </FadeInAnimation>

                {/* CTA Box */}
                <FadeInAnimation direction="up" delay={300}>
                    <div className="metabase-cta__cta-box">
                        <div className="metabase-cta__cta-content">
                            <div className="metabase-cta__cta-text">
                                <h4 className="metabase-cta__cta-title">
                                    {t("metabase_cta_title6")}
                                </h4>
                                <p className="metabase-cta__cta-description">
                                    {t("metabase_cta_description6")}
                                </p>
                            </div>

                            <div className="metabase-cta__cta-actions">
                                <div className="metabase-cta__contact-label">
                                    {t("metabase_cta_title7")}
                                </div>
                                <div className="metabase-cta__social-links">
                                    <a href="tel://+4943170577024" className="metabase-cta__social-link" aria-label="Telefon">
                                        <BiPhone />
                                    </a>
                                    <a href="mailto:info@simplify-data.de" className="metabase-cta__social-link" aria-label="E-Mail">
                                        <BiEnvelope />
                                    </a>
                                    <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank" rel="noopener noreferrer" className="metabase-cta__social-link" aria-label="LinkedIn">
                                        <BiLogoLinkedin />
                                    </a>
                                </div>
                                <Link href="/kontakt" className="metabase-cta__button metabase-cta__button--light">
                                    <span>{t("metabase_cta_button")}</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </FadeInAnimation>
            </div>
        </section>
    );
};

export default MetabaseCTA;
